import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import {
  WRichTextDefinition,
  WRichTextProps,
} from '@wix/thunderbolt-components';

const props = withCompPreviewProps<WRichTextProps, WRichTextDefinition>()(
  ['skin', 'compPreviewState'],
  ({ skin, compPreviewState }, carmiData) => {
    const data = (carmiData as unknown) as WRichTextProps;

    return {
      skin,
      html: data.html,
      previewWrapperProps: { compPreviewState },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
